// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import produce from 'immer';
import { GET_LIST_NOTIFICATION_DONE, GET_COUNT_TOTAL_NOTIFICATION_DONE } from './constant';

export type DanhSachKhoHangState = {
  listNoti: any;
  countNoti: any;
};

const initState: DanhSachKhoHangState = {
  listNoti: [],
  countNoti: 0
};

const thongBaoReducer = (
  state = initState,
  action: ActionType,
): DanhSachKhoHangState => {
  return produce(
    state,
    (draftState: DanhSachKhoHangState): DanhSachKhoHangState => {
      switch (action.type) {
        case GET_LIST_NOTIFICATION_DONE:
          draftState.listNoti = action.payload;
          return draftState;
        case GET_COUNT_TOTAL_NOTIFICATION_DONE:
          draftState.countNoti = action.payload;
          return draftState;
        default:
          return draftState;
      }
    },
  );
};

export default thongBaoReducer